// store.js
import { reactive, computed } from "vue";
// import { rp, tour } from "@/components/tour.vue";

export const sceneManager = reactive({
  selectedLVI: null,
  iframeWindow: null,
  activeCategory : "Viewpoints",
  WQMitigatedState: true,
  mapShow: true,
  currentScene: "",
  triggerOverlayName: "impact_noise_def",
  currentFocus: "none",
  noiseBarrierVisible: false,
  // Current noise scenario for syncing legends in the right panel
  // Possible values: 'mitigated' | 'unmitigated' | 'prevailed'
  noiseScenario: 'mitigated',
  // Flags from noise panel legend parameters, e.g. ['yellow1'] or ['yellow_green']
  noiseLegendFlags: [],
  iframeSrc: computed(() => {
    return `/tour/index.html?media-name=${sceneManager.currentScene}&hide-components-tags=landing_page&trigger-overlay-name=${sceneManager.triggerOverlayName}&focus-overlay-name=${sceneManager.triggerOverlayName}`;
  }),
  rp: null,
  RP() {
    this.rp = this.iframeWindow.tour._getRootPlayer();
    return this.rp;
  },
  setNoiseScenario(scenario) {
    if (scenario === 'mitigated' || scenario === 'unmitigated' || scenario === 'prevailed') {
      this.noiseScenario = scenario;
    }
  },
  setNoiseLegendFlags(flags) {
    if (Array.isArray(flags)) {
      this.noiseLegendFlags = flags;
    } else if (typeof flags === 'string') {
      this.noiseLegendFlags = flags.split(',').map(s => s.trim()).filter(Boolean);
    }
  },
  setCurrentScene(name) {
    console.log("setting scene to " + name);
    name = name.replace("-", "");
    this.currentScene = name;
    // Reset noise barrier state when entering new VP
    this.noiseBarrierVisible = false;
  },
  //manipulate tour in iframe in tour.vuw
  manipulateTour() {
    console.log(
      this.iframeWindow.tour._getRootPlayer().mainPlayList.get("items")
    );
  },

  // generateUrl() {
  //   let url = this.iframeSrc;
  //   return url;
  // },
  setScene(a) {
    console.log(a);
  },
  test() {
    console.log("test");
  },

  getVPName() {
    let VpArray = this.RP().mainPlayList.get("items");

    let VpTitleArray = [];

    for (let i = 0; i < VpArray.length; i++) {
      let VpItem = VpArray[i];

      let VpItemTitle = VpItem["media"]["label"];

      VpTitleArray.push(VpItemTitle);
    }
    console.log(VpTitleArray);

    return VpTitleArray;
  },

  // Toggle noise barrier info overlays
  toggleNoiseBarrierInfo() {
    if (this.iframeWindow && this.iframeWindow.tour) {
      let rp = this.iframeWindow.tour._getRootPlayer();
      
      if (this.noiseBarrierVisible) {
        // Hide noise barriers
        rp.setOverlaysVisibilityByTags(["noise_barrier_tooltip"], false, rp.getMediaByName(""), "or", 0);
        this.noiseBarrierVisible = false;
        console.log("Noise barrier info overlays hidden");
      } else {
        // Show noise barriers
        rp.setOverlaysVisibilityByTags(["noise_barrier_tooltip"], true, rp.getMediaByName(""), "or", 0);
        this.noiseBarrierVisible = true;
        console.log("Noise barrier info overlays shown");
      }
    } else {
      console.warn("Tour iframe not loaded or available");
    }
  },
  //get the iframe in tour.vue
});
